import { SET_SECURITY_LIST, DB_CONNECTION } from './types';

export const setSecurityList = (securityList: any) => (dispatch: any) => {
  dispatch({ type: SET_SECURITY_LIST, payload: securityList });
};

export const setDatabaseConnection = (connected: boolean) => (dispatch: any) => {
  dispatch({ type: DB_CONNECTION, payload: connected });
};
